export default "__VITE_ASSET__BT6E2wfw__"